import React from 'react';
import { Card, CardTitle } from './UI';
import { AlertTriangle, CheckCircle2, Clock, Moon, Coffee } from 'lucide-react';

export default function HosPanel({ hos }) {
  if (!hos) return null;
  const { hos_compliant, hos_warnings = [], hos_legs = [] } = hos;
  return (
    <div
      className="mt-3 rounded-xl p-3.5"
      style={{
        background: hos_compliant ? '#f0fdf4' : '#fff7ed',
        border: `1px solid ${hos_compliant ? '#bbf7d0' : '#fed7aa'}`,
      }}
    >
      <div className="flex items-center gap-2 mb-2">
        {hos_compliant ? (
          <CheckCircle2 size={16} style={{ color: 'var(--lf-green)' }} />
        ) : (
          <AlertTriangle size={16} style={{ color: '#c2410c' }} />
        )}
        <b className="text-sm" style={{ color: hos_compliant ? '#166534' : '#9a3412' }}>
          FMCSA HOS {hos_compliant ? 'compliant' : 'needs attention'}
        </b>
      </div>
      {hos_warnings.length > 0 && (
        <ul className="text-xs mb-2 space-y-0.5" style={{ color: '#9a3412' }}>
          {hos_warnings.map((w, i) => (
            <li key={i}>• {w}</li>
          ))}
        </ul>
      )}
      <div className="flex flex-wrap gap-2">
        {hos_legs.map((leg, i) => {
          if (leg.rest) {
            return (
              <div
                key={i}
                className="inline-flex items-center gap-1.5 text-xs font-semibold px-2 py-1 rounded"
                style={{ background: '#e0e7ff', color: '#3730a3' }}
              >
                <Moon size={11} /> Rest {leg.rest_hours}h
              </div>
            );
          }
          return (
            <div
              key={i}
              className="inline-flex items-center gap-1.5 text-xs font-semibold px-2 py-1 rounded"
              style={{ background: '#ffffff', border: '1px solid #d1d5db' }}
            >
              <Clock size={11} /> Shift {leg.shift}: drive {leg.drive_hours}h
              {leg.break && (
                <span className="inline-flex items-center gap-1 ml-1" style={{ color: '#92400e' }}>
                  <Coffee size={10} /> 30m break
                </span>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}
